import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SuperhogDashboard, SuperhogPublicProfile, VerificationRequestStatus, GuestReport } from 'models';

@Injectable({
	providedIn: 'root',
})
export class SuperhogService {
	constructor(private http: HttpClient) {}

	public get(): Observable<SuperhogDashboard> {
		return this.http.get<SuperhogDashboard>('api/superhog/get');
	}

	public getPublicProfile(userId: string): Observable<SuperhogPublicProfile> {
		return this.http.get<SuperhogPublicProfile>(`api/superhog/getpublicprofile/${userId}`);
	}

	public getVerificationSummary(): Observable<VerificationRequestStatus[]> {
		return this.http.get<VerificationRequestStatus[]>('api/superhog/verificationsummary');
	}

	public getGuestReport(bookingViewId: number): Observable<GuestReport> {
		return this.http.get<GuestReport>(`api/superhog/guestreport/${bookingViewId}`);
	}
}
